import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { CONTACT } from "@/lib/contacts";

/**
 * Mobile-only bottom bar that appears once the visitor scrolls past the hero.
 */
const StickyRegisterBar = ({ visible }) => {
  const { t } = useLanguage();

  return (
    <div
      data-testid="sticky-register-bar"
      aria-hidden={!visible}
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[rgb(var(--brand-rgb)/0.35)] bg-[#050505]/95 backdrop-blur-xl px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={CONTACT.registration}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={visible ? 0 : -1}
        data-testid="sticky-register-btn"
        className="flex items-center justify-between gap-3 w-full h-13 px-5 py-3 rounded-full bg-[var(--brand)] text-black font-bold text-sm"
      >
        <span className="flex flex-col text-left leading-tight">
          <span>{t.sticky.label}</span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-black/70">
            {t.sticky.note}
          </span>
        </span>
        <ArrowRight className="h-5 w-5 shrink-0" aria-hidden="true" />
        <span className="sr-only">{t.a11y.external}</span>
      </a>
    </div>
  );
};

export default StickyRegisterBar;
